@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@use '@helsenorge/designsystem-react/scss/breakpoints' as breakpoints;

.feedbackmodal {
  border-radius: 12px;
  border: 4px solid var(--color-help-graphics);
  background-color: palette.$white;
  padding: spacers.getSpacer(m);
  inset: auto;
  margin: 0;
  position: fixed;
  bottom: max(spacers.getSpacer(s), env(safe-area-inset-bottom));
  right: max(spacers.getSpacer(s), env(safe-area-inset-bottom));
  left: max(spacers.getSpacer(s), env(safe-area-inset-left));
  z-index: 110000; // Over header og chat-knapp
  max-width: 696px;

  @media (min-width: map.get(breakpoints.$grid-breakpoints, md)) {
    padding: spacers.getSpacer(l);
  }

  &__header {
    display: flex;
    align-items: start;
    gap: spacers.getSpacer(s);
    padding-right: spacers.getSpacer(xl);
    margin-bottom: spacers.getSpacer(m);
  }

  &__title {
    padding-top: spacers.getSpacer(2xs);
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: spacers.getSpacer(m);
  }

  &__actions {
    display: flex;
    gap: spacers.getSpacer(xs);
  }

  &__close {
    position: absolute;
    top: spacers.getSpacer(2xs);
    right: spacers.getSpacer(2xs);
  }
}
